import React from 'react'
import { useIntl } from 'react-intl'
import Link from 'next/link'

import { buildLocation } from 'lib/utils'

import styles from './styles.module.css'
import { Text } from 'src/comps/Atom/Text'

interface IMoreAccomodationsProps {
  city: string
  resultsUrl: ReturnType<typeof buildLocation>
}

const MoreAccommodations = ({ city, resultsUrl }: IMoreAccomodationsProps) => {
  const intl = useIntl()

  return (
    <div className={styles.moreAccomodationsBase}>
      <Text variant="titleXs" as="h6">
        {intl.formatMessage({ id: 'global.perfect-hotel' })}
      </Text>
      <Link {...resultsUrl}>
        <a className={styles.link}>
          {intl.formatMessage({ id: 'global.more-accommodations' }, { city })}
        </a>
      </Link>
    </div>
  )
}

export default MoreAccommodations
